export default {
  data() {
    return {
      user: {
        firstName: 'John',
        lastName: 'Doe'
      },
      // Login screen demo data
      username: '',
      password: ''
    };
  },

  methods: {
    helloWorld() {
      this.$f7.dialog.alert('Hello World!');
    },

    updateUsername(e) {
      this.username = e.target.value;
      this.$update();
    },

    updatePassword(e) {
      this.password = e.target.value;
      this.$update();
    },

    alertLoginData() {
      this.$f7.dialog.alert('Username: ' + this.username + '<br>Password: ' + this.password, () => {
        this.$f7.loginScreen.close();
      });
    }

  },
  id: 'a8ad3717c5',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div id="app">\n\n    <!-- Left panel with cover effect-->\n    <div class="panel panel-left panel-reveal panel-init">\n      <div class="view">\n        <div class="page">\n          <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner">\n              <div class="title"></div>\n            </div>\n          </div>\n          <div class="page-content">\n            <div class="block">Left panel content goes here</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- Right panel with reveal effect-->\n    <div class="panel panel-right panel-cover theme-dark">\n      <div class="view">\n        <div class="page">\n          <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner">\n              <div class="title"></div>\n            </div>\n          </div>\n          <div class="page-content">\n            <div class="block">\n              <h2 class="panel-title">메인 페이지</h2>\n              <ul>\n                <li>마이 페이지</li>\n                <li>찜 목록</li>\n                <li>설정</li>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!-- Your main view, should have "view-main" class -->\n    <div class="view view-main view-init safe-areas" data-url="/"></div>\n\n\n    <!-- Popup -->\n    <div class="popup" id="my-popup">\n      <div class="view">\n        <div class="page">\n          <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner">\n              <div class="title">Popup</div>\n              <div class="right">\n                <a href="#" class="link popup-close">Close</a>\n              </div>\n            </div>\n          </div>\n          <div class="page-content">\n            <div class="block">\n              <p>Popup content goes here.</p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!-- Login Screen -->\n    <div class="login-screen" id="my-login-screen">\n      <div class="view">\n        <div class="page">\n          <div class="page-content login-screen-content">\n            <div class="login-screen-title">Login</div>\n            <div class="list">\n              <ul>\n                <li class="item-content item-input">\n                  <div class="item-inner">\n                    <div class="item-title item-label">Username</div>\n                    <div class="item-input-wrap">\n                      <input type="text" name="username" placeholder="Your username" value="';
      r += c(ctx_1.username, ctx_1);
      r += '" @input="updateUsername">\n\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input">\n                  <div class="item-inner">\n                    <div class="item-title item-label">Password</div>\n                    <div class="item-input-wrap">\n                      <input type="password" name="password" placeholder="Your password" value="';
      r += c(ctx_1.password, ctx_1);
      r += '" @input="updatePassword">\n\n                    </div>\n                  </div>\n                </li>\n              </ul>\n            </div>\n            <div class="list">\n              <ul>\n                <li>\n                  <a href="#" class="item-link list-button login-button" @click="alertLoginData">Sign In</a>\n\n                </li>\n              </ul>\n              <div class="block-footer">Some text about login information.<br>Click "Sign In" to close Login Screen</div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n';
      return r;
    }(this);
  },

  style: `
  * {
    user-select: none;
  }
  
  .panel-right {
    width: 185px;
    height: 100vh;
    background-color: transparent;
  }

  .panel-right::after {
    display: none;
  }

  .panel-right .page {        
    background-color: rgba(190, 163, 107, 0.42);
    -webkit-backdrop-filter: blur(15px);
    backdrop-filter: blur(10px);
    border-top-left-radius: 50px;
  }

  .panel-right h2.panel-title {
    margin-top: 24.4vh;
    margin-left: 5.8vw;
    font-size: 5.3vw;
  }

  .panel-right ul {
    list-style: none;
    font-size: 5vw;
    padding-left: 6.2vw;
    margin-top: -1vh;
  } 

  .panel-right li {
    height: 40px;
    transition: color 200ms ease;
  }

  .panel-right li:hover {
    color: rgba(0, 122, 255, 0.6);
  }
`,
  styleScoped: false
};